import { Form, Row } from 'antd';
import classNames from 'classnames/bind';
import { SVGS } from '~/assets/assetsPath';
import styles from './FormLogOut.module.scss';

const cx = classNames.bind(styles);

const LogOutModal = ({ onLogOut, onCancel }) => {
    return (
        <Form>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Log out
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    Do you want to log out?
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center">
                    <img src={SVGS.IconLogOut} alt="" />
                </Row>
            </Form.Item>
            <Form.Item style={{ marginTop: '40px' }}>
                <Row>
                    <div className={cx('btn_cancel')} onClick={onCancel}>
                        Cancel
                    </div>
                    <div className={cx('btn_logout')} onClick={onLogOut}>
                        Log out
                    </div>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default LogOutModal;
